<div class="w-full flex items-center flex-wrap">
    <ng-container *ngFor="let tag of listTag">
    <nz-tag
    [nzColor]="'green'"
    *ngIf="tag"
    (nzOnClose)="onclose()"
    >{{ tag }}</nz-tag>
  </ng-container>

</div>